function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-2-2h24v24H-2z"
}), React.createElement("path", {
  d: "M4.508 15.475a2.275 2.275 0 0 1 0 3.218C3.619 19.582.4 19.6.4 19.6v-.044c.004-.391.063-3.254.89-4.08a2.275 2.275 0 0 1 3.218 0zM19.546.458l-.05.89c-.178 3.125-1.07 5.857-2.52 8.216a7.2 7.2 0 0 1-1.674 7.578c-.34.341-.716.644-1.126.912l-.313.195-.534.315-2.74-2.74-.068.04-.433.251-.39.214-.179.094-.32.158-.14.066-.242.105-.492.201-5.279-5.279.277-.667c.18-.409.46-.957.846-1.602L1.436 6.671l.315-.534a7.175 7.175 0 0 1 1.106-1.44 7.2 7.2 0 0 1 7.539-1.682c2.364-1.457 5.111-2.347 8.26-2.51l.89-.047zm-3.78 10.83l-.184.227c-.436.531-.904 1.04-1.402 1.527a19.736 19.736 0 0 1-2.231 1.88l1.611 1.61.196-.148c.073-.059.144-.12.213-.181l.202-.192a5.604 5.604 0 0 0 1.595-4.723zM12.182 3.84c-1.542.804-2.92 1.86-4.144 3.127a18 18 0 0 0-3.025 4.212l-.066.133 3.737 3.737.331-.17c.144-.077.294-.16.448-.25l.236-.138a18.16 18.16 0 0 0 3.363-2.593c1.242-1.216 2.282-2.58 3.078-4.101L12.182 3.84zM10.468 7.27a1.6 1.6 0 1 1 2.263 2.262 1.6 1.6 0 0 1-2.263-2.262zm-6.48-1.44a5.26 5.26 0 0 0-.372.415l-.15.194 1.6 1.602a19.545 19.545 0 0 1 1.822-2.185 18.74 18.74 0 0 1 1.776-1.62 5.59 5.59 0 0 0-4.675 1.594zm13.834-3.656l-.383.045a15.815 15.815 0 0 0-3.697.919l3.103 3.103c.446-1.15.762-2.381.933-3.695l.044-.372z",
  fill: "#475059",
  strokeLinecap: "square"
}));

var SvgIconLatestDeployments = function SvgIconLatestDeployments(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-latest-deployments.a332e399.svg";
export { SvgIconLatestDeployments as ReactComponent };